import * as React from 'react';
import type { SVGProps } from 'react';
const FilePack = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#prefix__a)">
      <path
        fill="#FF650F"
        d="M21.177 0h-6.353c.423 0 .705.282.705.706 0 .423-.282.706-.706.706h-1.411c-.424 0-.706-.283-.706-.706 0-.424.282-.706.706-.706H2.824A2.83 2.83 0 0 0 0 2.824v18.353A2.83 2.83 0 0 0 2.824 24h18.353A2.83 2.83 0 0 0 24 21.177V2.823A2.83 2.83 0 0 0 21.177 0m-12 1.412h1.411c.424 0 .706.282.706.706 0 .423-.282.706-.706.706H9.176c-.423 0-.705-.283-.705-.706 0-.424.282-.706.705-.706m0 2.823h1.411c.424 0 .706.283.706.706 0 .424-.282.706-.706.706H9.176c-.423 0-.705-.282-.705-.706 0-.423.282-.706.705-.706m0 2.824h1.411c.424 0 .706.282.706.706 0 .423-.282.706-.706.706H9.176c-.423 0-.705-.283-.705-.706 0-.424.282-.706.705-.706m6.352 7.059a2.83 2.83 0 0 1-2.823 2.823h-1.412a2.83 2.83 0 0 1-2.823-2.823V9.882h7.058zm-.706-7.06h-1.411c-.424 0-.706-.282-.706-.705 0-.424.282-.706.706-.706h1.411c.424 0 .706.282.706.706 0 .423-.282.706-.706.706m0-2.823h-1.411c-.424 0-.706-.282-.706-.706 0-.423.282-.705.706-.705h1.411c.424 0 .706.282.706.705 0 .424-.282.706-.706.706"
      />
    </g>
    <defs>
      <clipPath id="prefix__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default FilePack;

